module.exports = __webpack_public_path__ + "components/country-flag/static/tz-f8ab9ad52197acc1e6fc4510f0dc9f10.svg";